import React from 'react';

import { colors } from 'helpers/ColorHelper';
import { featureEnabled } from 'helpers/ToggleBot';
import { getTranslatedString } from 'helpers/i18n';
import { MdWarning as WarningIcon } from 'react-icons/md';

export const BouncedEmailWarning = ({ isBouncedEmail, userName }) => {
  if (!featureEnabled('bounce_emails')) return null;
  if (!isBouncedEmail) return null;

  let bouncedEmailVerbiage = null;
  bouncedEmailVerbiage = (
    <div style={{ paddingTop: '10px', paddingBottom: '15px' }}>
      <WarningIcon
        size={14}
        style={{
          marginBottom: '2px',
          marginRight: '5px',
          verticalAlign: 'text-bottom',
          color: colors.PUMPKIN_ORANGE,
        }}
      />
      {getTranslatedString('landlordPortal.tenantDetails.bouncedEmail', {
        name: userName,
      })}
    </div>
  );

  return (
    <div className="row">
      <p style={{ marginBottom: '5px' }}>{bouncedEmailVerbiage}</p>
    </div>
  );
};
